"use strict";

exports.__esModule = true;
exports.AllDeviceListContext = void 0;
var _Utils = require("../../../Utils");
/**
 * Provides a list of devices to consumers.
 * @component
 */

var AllDeviceListContext = exports.AllDeviceListContext = (0, _Utils.createEnhancedContext)({
  propName: "allDevices"
});